import React from 'react'
import Footer from '../../../components/Footer'
import ScienceImg from "../../../assets/images/environment.jpeg";
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';

const MscEnvironment = () => {
    return (
        <div className='  w-full relative font-poppins ' >
            <Title canonicalPath="/programmes/ug-courses/sciences/msc/environmental-science" />
            <Title title="M.Sc. in Environmental Sciences at Maya Devi University" description="Enroll in the M.Sc. in Environmental Sciences program at Maya Devi University, Dehradun. Gain advanced knowledge to address global environmental challenges." />
            <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
                <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>M.Sc. Environmental Sciences</h2>
                <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
                <div className=' flex flex-col md:flex-row gap-8 mb-10 md:gap-[60px] mt-5 justify-center md:justify-between ' >
                    <img src={ScienceImg} className=' md:w-[40%] rounded-lg ' />
                    <div className=' flex flex-col gap-4 ' >
                        <h4 className=' font-bold text-xl md:text-3xl ' >About the Department</h4>
                        <p className=' text-justify md:text-md ' >M.Sc. Environmental Science programme is a full-time, one year/two-year postgraduate program dedicated to explore the environment and its diverse elements, encompassing physical, chemical, and biological facets.
                            <br /><br />
                            The Department of Environmental Studies offers opportunities to develop interests in diverse  areas, including environmental science; public health; environmental values, policy, and law; earth system science; environmental monitoring; urban environmental problems; energy systems; climate change; environmental justice and our complex relations with both domesticated and wild nature.
                            <br /><br />
                            Department of Environmental Sciences is a part of School of Applied Sciences working as an interdisciplinary center to learn and disseminate the knowledge in various aspects of environment. The course curriculum is designed with the help of experts from academia and industries to train the manpower required for working in the field of environmental sciences.

                            Department of Environmental Sciences is committed to provide an excellent educational and research experience that includes real life environmental problem solving, field and laboratory work.</p>
                        <Link to="https://admission.maya.edu.in/" >
                            <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                            >Register Now</button>
                        </Link>
                    </div>
                </div>

                <div className=' flex flex-col gap-10 mt-5 mb-[20px] ' >
                    <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
                        <p>B.Sc. with minimum 50% marks either in EVS or Botany-Zoology-Chemistry (Medical stream)</p>
                    </div>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                    <p>After completion of the program, the students have:</p>
                    <ul className=' list-disc ' >
                        <li>Gained research acumen and creative thinking skills to gather, analyze, and report on complex environmental data.</li>
                        <li>Laboratory skills for analyzing environmental data.</li>
                        <li>Written and verbal communication skills, including presentation skills.</li>
                        <li>Flexibility to work in all kinds of environments, developed through working in the field.</li>
                        <li>Developed numerical and IT skills.</li>
                        <li>Planning, time management, and project-management skills.</li>
                        <li>Acquired the sense of responsibility to safeguard the environment as a constitutional duty.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                    <ul className=' list-disc ' >
                        <li>The students passing M.Sc. Degree in the subject Environmental Science  have the job opportunity in the field of Teaching, Researches, Projects, Effluent Treatment Plants of various Industries/Companies/Factories, Municipal Councils/Corporations, Central Pollution Control Board, State Pollution Control Boards, National Research Institutes/Organizations/Laboratories, NEERI, EIA, GIS, Environmental Monitoring Projects, Environmental Consultants.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                    <ul className=' list-disc ' >
                        <li>Environmental Scientist/Officer</li>
                        <li>Nature Conservation Officer/Waste Management Officer</li>
                        <li>Sustainability Consultant</li>
                        <li>Environmental Education Officer/Environmental Journalist</li>
                        <li>Water Quality Scientist</li>
                        <li>Product Manager – Environmental Health & Safety</li>
                        <li>Environmental Monitoring Organizations</li>
                    </ul>
                </div>

                {/* table */}
                <div className="flex flex- mb-[100px] ">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                            <div className="overflow-hidden">
                                <table className="min-w-full text-center text-sm font-light">
                                    <thead
                                        className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                                        <tr>
                                            <th scope="col" className=" px-6 py-4">Programme</th>
                                            <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
                                            <th scope="col" className=" px-6 py-4">Duration (Years)</th>
                                            <th scope="col" className=" px-6 py-4">No. of Seats</th>
                                            {/* <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Master of Science</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Environmental Science</td>
                                            <td className="whitespace-nowrap  px-6 py-4">2</td>
                                            <td className="whitespace-nowrap  px-6 py-4">20</td>
                                            {/* <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default MscEnvironment